var ReadMore = class extends HTMLElement {
    constructor() {
        super();
        this.expanded = false;
        this.boundToggle = this.toggle.bind(this);
        this.boundSetInitialHeight = this.setInitialHeight.bind(this);
    }

    connectedCallback () {
        this.gridCard = this.closest(".collection__summary");
        this.content = this.querySelector(".content");
        // Images inside content should only be visible when expanded
        this.contentImages = this.content ? Array.from(this.content.querySelectorAll('img')) : [];
        this.button = this.querySelector("button.read-more");
        this.visibleRows = parseInt(this.getAttribute("data-visible-rows")) || 2;

        this.updateState();
        this.button?.addEventListener("click", this.boundToggle);
        window.addEventListener("resize", this.boundSetInitialHeight);
    }

    disconnectedCallback () {
        this.button?.removeEventListener("click", this.boundToggle);
        window.removeEventListener("resize", this.boundSetInitialHeight);
    }

    toggle () {
        this.expanded = !this.expanded;
        this.updateState();
    }

    updateState () {
        if (!this.content || !this.button) return;

        if (this.expanded) {
            this.content.classList.add("expanded");
            this.gridCard?.classList.add("expanded");
            this.button.textContent = this.button.dataset.expandedText;
            // show images when expanded
            this.contentImages?.forEach((img) => {
                img.style.display = '';
            });
        } else {
            this.setInitialHeight();
            this.content.classList.remove("expanded");
            this.gridCard?.classList.remove("expanded");
            this.button.textContent = this.button.dataset.collapsedText;
            // hide images when collapsed
            this.contentImages?.forEach((img) => {
                img.style.display = 'none';
            });
        }
    }
    setInitialHeight () {
        if (!this.content) return;

        // Ignore images when calculating the collapsed height so they don't inflate the clamp.
        const blocks = Array.from(this.content.children).filter((el) => {
            const tag = el.tagName?.toLowerCase();
            return tag !== 'img';
        });

        if (blocks.length === 0) return;

        let firstLineBlocksHeight;

        if (blocks[0].tagName.toLowerCase() === 'p' || blocks[0].tagName.toLowerCase() === 'span') {
            const computedStyle = window.getComputedStyle(blocks[0]);
            firstLineBlocksHeight = parseFloat(computedStyle.lineHeight);
        } else {
            firstLineBlocksHeight = Math.max(
                blocks[0].getBoundingClientRect().height || 0,
                blocks[1]?.getBoundingClientRect().height || 0
            );
        }

        const totalHeight = (firstLineBlocksHeight * this.visibleRows);

        // assign to CSS variable
        this.content.style.setProperty('--max-visible-height', totalHeight + 'px');
    }
}

if (!customElements.get('read-more')) {
    customElements.define('read-more', ReadMore);
}